import React, { forwardRef } from 'react';
import AsyncSelect from 'react-select/async';
import type { AsyncProps } from 'react-select/async';
import type { GroupBase, StylesConfig, CSSObjectWithLabel } from 'react-select';

import { Option, OptionValue } from 'components/TotemSelect';
import { TotemLabel } from './TotemLabel';

type TotemAsyncSelectProps<T extends OptionValue> = AsyncProps<Option<T>, boolean, GroupBase<Option<T>>> & {
    label?: string;
    sublabel?: string;
    name: string;
    width?: string;
    isClearable?: boolean;
    dataTest?: string;
    placeholder?: string;
};

const TotemAsyncSelectComponent = <T extends OptionValue>(
    { label, sublabel, name, width, dataTest = '', placeholder = '', ...props }: TotemAsyncSelectProps<T>,
    ref: React.ForwardedRef<any>,
) => {
    const selectStyles: StylesConfig<Option<T>, boolean, GroupBase<Option<T>>> = {
        control: (base: CSSObjectWithLabel) => {
            return {
                ...base,
                minHeight: 45,
            };
        },
    };

    return (
        <div className="flex flex-col gap-[5px]" style={{ width: width || '100%' }}>
            {label || sublabel ? (
                <div className="flex flex-col">
                    {label ? <TotemLabel>{label}</TotemLabel> : null}
                    {sublabel ? <span className="text-muted-foreground text-[13px]">{sublabel}</span> : null}
                </div>
            ) : null}
            <div className="text-black relative" data-test={dataTest}>
                <AsyncSelect
                    ref={ref}
                    placeholder={placeholder || 'Aucune valeur'}
                    cacheOptions
                    closeMenuOnSelect={!props.isMulti}
                    styles={selectStyles}
                    {...props}
                />
            </div>
        </div>
    );
};

export const TotemAsyncSelect = forwardRef(TotemAsyncSelectComponent) as <T extends OptionValue>(
    props: TotemAsyncSelectProps<T> & { ref?: React.ForwardedRef<any> },
) => JSX.Element;
